import {Injectable} from "@angular/core";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Observable} from "rxjs";
import {User} from "src/app/infrastructure/moovement-api/models/user";

@Injectable({
  providedIn: 'root'
})
export class UserApiClient extends MoovementApiClient {

  updateUser(user: User): Observable<User> {
    return this.httpClient.post<User>(`${this.baseUrl}/api/user`, user);
  }

  getUser(id: string): Observable<User> {
    return this.httpClient.get<User>(`${this.baseUrl}/api/user/${id}`);
  }
}
